module.exports = __webpack_public_path__ + "pigmentace_3_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/pigmentace_3_before.jpg
// module id = 974
// module chunks = 0